import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext'; // Import useAuth
import { handleLoginCallback } from 'utils/auth';

const OAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useAuth(); // Get login from AuthContext

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const code = query.get('code');

    if (code) {
      handleLoginCallback(code)
        .then(accessToken => {
          login(accessToken, code); // Pass the code to the login function
          const redirectPath = localStorage.getItem('redirect_path') || '/';
          localStorage.removeItem('redirect_path'); // Clean up after use
          navigate(redirectPath);
        })
        .catch(() => {
          navigate('/login');
        });
    } else {
      navigate('/login');
    }
  }, [location.search, navigate, login]); // Updated dependency to include login

  return <div>Loading...</div>;
};

export default OAuthCallback;
